import { html, View } from 'rune-ts';
import klass from './ExhibitionSection.module.scss';

interface ExhibitionCardProps {
  imageUrl: string;
}
export class ExhibitionCard extends View<ExhibitionCardProps> {
  override template({ imageUrl }: ExhibitionCardProps) {
    return html`
      <div class="${klass.exhibition_card}">
        <img src="${imageUrl}" alt="랜딩페이지 베이스 상품 이미지" class="${klass.exhibition_image}" />
      </div>
    `;
  }
}
